const fibNumber = (position: number): number => {
  if (position <= 1) return position;

  return fibNumber(position - 1) + fibNumber(position - 2);
};

const fib = (position: number, endPosition: number): number[] => {
  if (position < endPosition) return [];

  return [fibNumber(position), ...fib(position - 1, endPosition)];
};

const generateIntervals = (): number[] => {
  return fib(7, 4)
    .reverse()
    .map((element) => element * 1000 + 1000);
};

const POST_PAYMENT_POLL_DELAY = 120_000;

interface PollDriverParams<T> {
  functionToPoll: () => Promise<T>;
  shouldStop: (result: T) => boolean;
  initialDelay?: number;
}

const pollDriver = <T>({ functionToPoll, shouldStop, initialDelay = 0 }: PollDriverParams<T>): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    let intervalIndex = 0;
    const intervals = generateIntervals();

    const poll = (): void => {
      const timer = setTimeout(async () => {
        try {
          const result = await functionToPoll();
          if (shouldStop(result) || intervalIndex >= intervals.length) {
            clearTimeout(timer);
            return resolve(result);
          }
          poll();
        } catch (error) {
          clearTimeout(timer);
          if (intervalIndex >= intervals.length) {
            return reject(error);
          }
          poll();
        }
      }, intervals[intervalIndex++]);
    };

    setTimeout(async () => {
      try {
        const result = await functionToPoll();
        if (shouldStop(result)) return resolve(result);
        poll();
      } catch (error) {
        poll();
      }
    }, initialDelay);
  });
};

export { pollDriver, POST_PAYMENT_POLL_DELAY };
